import React from "react";
import SensorBase from "./SensorBase";

const FIELD = "soilMoisture2";
const UNIT = "kPa";

const SoilMoisture2: React.FC = () => {
  return (
    <SensorBase field={FIELD} unit={UNIT}></SensorBase>
  );
};

export default SoilMoisture2;
